<template>
  <div class="sa-base-category-manage">
    <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
      
      <template slot="lastHeaderColumns" slot-scope="props">
      <grid-table-th
        v-if="props.magicalMenuCodes.includes('cloudinfo-view-domain')"
        width="80px"
      >查看域名
      </grid-table-th>

    </template>
    <template slot="lastBodyColumns" slot-scope="props">
      <grid-table-td
        v-if="props.magicalMenuCodes.includes('cloudinfo-view-domain')"
        @click.native="handleCopyBaseCategory(props.row)"
        width="80px"
      >查看域名
      </grid-table-td>
    </template>
    </grid>
    <el-dialog :visible.sync="copyDialogVisible" custom-class="whaty-dialog-form" width="880px" @close="handleDialogClose" @open="handleDialogOpen">
      <div slot="title" class="popup-head">
        <span class="popup-tit">查看域名</span>
      </div>
      <div class="whaty-common-form" v-loading="loading">
        <div class="popup-body">
          <div class="popup-content">
            <div class="clearfix popup-content-in">
              <el-form ref="ruleForm" label-width="100px">
                <el-form-item label="域名列表" prop="conclusion">
	                <el-input type="textarea" class="resize-none-textarea" :readonly= true  v-model="domainList" :rows="18"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <div class="popup-foot group" style="text-align: right;">
        <a href="javascript:" class="btn btn btn-anti-default" @click="handleCancel">关闭</a>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import util from '@/libs/util'
import Grid from '@/components/grid/grid.vue'
import GridTopMenu from '@/components/grid-menu/grid-top-menu'
import DialogForm from '@/components/grid/dialog-form'
import GridBasicConfig from '@/super-admin/grid-manage/grid-basic-config.vue'
import GridColumnConfig from '@/super-admin/grid-manage/grid-column-config.vue'
import GridMenuConfig from '@/super-admin/grid-manage/grid-menu-config.vue'

import GridTableTh from '@/components/grid-menu/grid-table-th'
import GridTableTd from '@/components/grid-menu/grid-table-td'
import WhatyDialog from '@/components/dialog/dialog'

export default {
  components: {
    GridTopMenu,
    Grid,
    DialogForm,
    GridBasicConfig,
    GridColumnConfig,
    GridMenuConfig,
    GridTableTh,
    GridTableTd,
    WhatyDialog},
  name: 'clusterInfo-service-config',
  data() {
    return {
      loading: false,
      gridConfigUrl: '',
      copyDialogVisible: false,
      domainList: ''
    }
  },
  created() {
    this.gridConfigUrl = this.$route.meta.url
  },
  computed: {
  },
  methods: {
    // 加载webSite
    loadData(id) {
      let params = {
        bean: {'id': id}
      }
      util.ajax.post('/entity/dev/nginxConfig/clusterInfo/getDomainList', params).then((res) => {
        if (res.data.meta.errCode === 0) {
          let domainList = res.data.data
          this.domainList = ''
          if (domainList.length === 0) {
            this.domainList = '暂无数据'
            return
          }
          for (var i = 0; i < domainList.length; i++) {
            this.domainList += domainList[i] + '\n'
          }
        } else {
          this.$notify.info({title: '提示', message: '获取数据失败：' + res.data.meta.errMsg})
        }
      }).catch((err) => {
        this.$notify.error({title: '错误', message: '获取数据失败：'})
        console.error(err)
      })
    },
    // 打开dialog时
    handleDialogOpen() {
    },
    // 关闭dialog时
    handleDialogClose() {
      this.copyDialogVisible = false
    },
    // 复制基础功能按钮点击事件
    handleCopyBaseCategory(row) {
      this.domainList = ''
      this.copyDialogVisible = true
      this.loadData(row.id)
    },
    handleCancel() {
      this.copyDialogVisible = false
    }
  }
}
</script>
<style lang="scss">
.sa-base-category-manage {
  height: 100%;

  .el-form-item {
    margin-bottom: 0;
  }
  .form-table-wrap {
    margin: 0;
    padding: 8px 12px 8px 12px;
    line-height: 1;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}
.form-table-row {
  border-bottom: 1px solid #eee;
  vertical-align: bottom;
}

.resize-none-textarea textarea {
  resize: none;
}

</style>



// WEBPACK FOOTER //
// src/custom/components/nginxconfig/clusterInfo-service-config.vue